import { PageViewEvent } from '@shopify/events';
import { onDocumentReady } from '@theme/utilities';

// snippets/scripts.liquid maps @theme/sticky-add-to-cart in its importmap but
// never emits a <script> tag for it, so the custom element never registered and
// the mobile sticky buy bar stayed permanently off-screen. Importing it here --
// from a module that is already loaded unconditionally on every page -- registers
// the element. The module is a no-op on pages with no <sticky-add-to-cart>.
import '@theme/sticky-add-to-cart';

onDocumentReady(
  function dispatchPageViewEvent() {
    /** @type {HTMLElement | null} */
    const templateElement = document.querySelector('main[data-template]');
    const template = templateElement?.dataset.template || '';

    // -- Page --
    document.dispatchEvent(
      new PageViewEvent({
        page: {
          template,
          title: document.title,
          url: window.location.href,
        },
      })
    );
  },
  { once: true }
);
